import { permissionDenied } from 'assets/images'
import { Box, Button, Typography, styled } from '@mui/material'
import { ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'
import { Spinner } from '@campx-org/shared'
import { EvaluatorStore } from 'shared-state/UserStore'

const StyledBox = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
}))

type Props = {
  children: ReactNode
}

export default function AdminRouteGuard({ children }: Props) {
  const evaluator = EvaluatorStore.useState((s) => s.evaluator)
  const navigate = useNavigate()

  if (evaluator === null || evaluator === undefined) {
    return (
      <StyledBox>
        <Spinner />
      </StyledBox>
    )
  }

  if (!evaluator.isAdmin) {
    return (
      <StyledBox>
        <img src={permissionDenied} alt="permission denied" width={470} style={{ marginTop: '20px' }} />
        <Typography variant="h1">Permission Denied.</Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
          This area is available only for admin evaluators.
        </Typography>
        <Button sx={{ marginTop: '20px' }} onClick={() => navigate('/digital/bundles-assigned')}>
          Go to Dashboard
        </Button>
      </StyledBox>
    )
  }

  return <>{children}</>
}
